export default __webpack_public_path__ + "static/media/XFiles.d7b33142.mp3";